// extracted by mini-css-extract-plugin
export var loading_visible = "manim-examples-loading-module--loading_visible--c085c";
export var loadingdefault = "manim-examples-loading-module--loadingdefault--1d582";